import { useQuery } from '@tanstack/react-query';
import { Button, Callout, buttonClass } from '@gf/ui';
import { AuthHeading, AuthLayout } from './AuthLayout';
export function UpgradeOffer({token}:{token:string}) {
 const offer=useQuery({queryKey:['upgrade-offer',token],retry:false,queryFn:async()=> {
  const r=await fetch('/api/auth/signup/upgrade/view',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({token})});
  const data=await r.json();if(!r.ok)throw Error(data.error||'This offer is unavailable.');
  return data as {title:string;message:string;priceLabel:string;checkoutUrl:string};
 }});
 return <AuthLayout title="Your GramFather offer"><AuthHeading title={offer.data?.title||'Your GramFather offer'} lede="Continue your work with an offer prepared for your account." />
  {offer.isPending?<p>Loading your offer…</p>:offer.error?<Callout tone="danger">{offer.error.message}</Callout>:offer.data&&<div className="gf-stack">
   <p style={{whiteSpace:'pre-wrap'}}>{offer.data.message}</p><Callout title="Your offer">{offer.data.priceLabel}</Callout>
   <a className={buttonClass({variant:'primary',size:'lg'})} href={offer.data.checkoutUrl} rel="noreferrer">Review offer &amp; checkout</a>
   <p className="gf-muted">After checkout, our team will confirm your payment and restore your access. Your saved workspace stays in place.</p>
  </div>}
  <p><a href="mailto:jon@vaughnlabs.io">Contact support</a></p><Button variant="ghost" onClick={()=>location.assign('/login')}>Back to sign in</Button>
 </AuthLayout>;
}
